var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container mx"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('p',[_vm._v("Copyyright © "+_vm._s(_vm.year)+" at Dewhot.")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }